import React from 'react'
import PropTypes from 'prop-types'
import Textarea from 'react-textarea-autosize'

import * as styles from '../../styles'

const SimpleTextarea = (props) => <textarea {...props}></textarea>

const TextareaComponent = ({
  id,
  title,
  className,
  disabled,
  readOnly,
  value,
  rows = 4,
  minRows,
  maxRows,
  autoSize = false,
  placeholder,
  onKeyDown,
  onBlur,
  onClick,
  onChange,
  ...props
}) => {
  const Component = autoSize ? Textarea : SimpleTextarea

  return (
    <Component
      id={id}
      title={title}
      css={styles.input(props)}
      className={className}
      rows={rows}
      minRows={minRows}
      maxRows={maxRows}
      readOnly={readOnly}
      placeholder={placeholder}
      disabled={disabled}
      value={value}
      onClick={onClick}
      onKeyDown={onKeyDown}
      onBlur={onBlur}
      onChange={onChange}
    ></Component>
  )
}

TextareaComponent.propTypes = {
  id: PropTypes.string,
  title: PropTypes.string,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  readOnly: PropTypes.bool,
  value: PropTypes.any,
  rows: PropTypes.number,
  minRows: PropTypes.number,
  maxRows: PropTypes.number,
  placeholder: PropTypes.string,
  autoSize: PropTypes.bool,
  onKeyDown: PropTypes.func,
  onBlur: PropTypes.func,
  onClick: PropTypes.func,
  onChange: PropTypes.func,
}

export default TextareaComponent
